<!-- User profile header with PrimeNG Avatar -->
<div class="drawer-header">
    @if (user()?.profilePhotoUrl) {
        <p-avatar [image]="user()?.profilePhotoUrl" size="xlarge" shape="circle"></p-avatar>
    } @else {
        <p-avatar [label]="initials()" size="xlarge" shape="circle"></p-avatar>
    }
    <div class="user-info">
        <h3>{{ user()?.name }}</h3>
        <p>{{ user()?.email }}</p>
        @if (userRoles().length) {
            <ul class="user-roles">
                @for (role of userRoles(); track role) {
                    <li>{{ role | translate }}</li>
                }
            </ul>
        }
    </div>
</div>

<!-- Phone number field - full width -->
<div class="phone-form-field" [class.editing]="editingPhoneNumber()">
    <div class="p-inputgroup">
        <input
            pInputText
            class="phone-number-input"
            [placeholder]="'ENTER_PHONE_NUMBER' | translate"
            [formControl]="form.controls.phoneNumber"
            [readonly]="!editingPhoneNumber()"
            (keydown.enter)="editingPhoneNumber() && savePhoneNumber()"
        />
        @if (!editingPhoneNumber()) {
            <p-button icon="pi pi-pencil" [text]="true" severity="secondary" (onClick)="editPhoneNumber()" />
        }
        @if (editingPhoneNumber()) {
            <p-button
                icon="pi pi-check"
                [text]="true"
                severity="success"
                [disabled]="form.get('phoneNumber')?.invalid"
                (mousedown)="$event.preventDefault()"
                (onClick)="savePhoneNumber()"
            />
        }
    </div>
    @if (form.get("phoneNumber")?.invalid && form.get("phoneNumber")?.touched) {
        <small class="p-error">
            <app-core-errors [control]="form.get('phoneNumber')" />
        </small>
    }
</div>

<p-divider />

<form [formGroup]="form" class="drawer-content">
    <!-- Company Selection -->
    <div class="drawer-item">
        <div class="item-field">
            <label class="yllw-label">{{ "COMPANY_SELECTED" | translate }}</label>
            <p-select
                formControlName="company"
                [options]="companyOptions()"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"
                (onChange)="changeCompany($event)"
            >
                <ng-template #selectedItem let-selectedOption>
                    @if (selectedOption) {
                        <div class="selected-option">
                            <img [src]="'https://flagcdn.com/48x36/' + selectedOption.countryCode?.toLowerCase() + '.png'" alt="" class="select-flag" />
                            <span>{{ selectedOption.label }}</span>
                        </div>
                    }
                </ng-template>
                <ng-template #item let-option>
                    <div class="select-option">
                        <img [src]="'https://flagcdn.com/48x36/' + option.countryCode?.toLowerCase() + '.png'" alt="" class="select-flag" />
                        <span>{{ option.label }}</span>
                    </div>
                </ng-template>
            </p-select>
        </div>
    </div>

    <!-- Language Selection -->
    <div class="drawer-item">
        <div class="item-field">
            <label class="yllw-label">{{ "SELECT_USER_LANGUAGE" | translate }}</label>
            <p-select
                formControlName="userLanguage"
                [options]="languageOptions()"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"
                (onChange)="changeUserLanguage($event)"
            >
                <ng-template #selectedItem let-selectedOption>
                    @if (selectedOption) {
                        <div class="selected-option">
                            <img [src]="getLanguageFlagUrl(selectedOption.value)" alt="" class="select-flag" />
                            <span>{{ "LANGUAGE_OPTION." + selectedOption.value?.toUpperCase() | translate }}</span>
                        </div>
                    }
                </ng-template>
                <ng-template #item let-option>
                    <div class="select-option">
                        <img [src]="getLanguageFlagUrl(option.value)" alt="" class="select-flag" />
                        <span>{{ "LANGUAGE_OPTION." + option.value?.toUpperCase() | translate }}</span>
                    </div>
                </ng-template>
            </p-select>
        </div>
    </div>
</form>

<p-divider />

<div class="drawer-link" (click)="openKeyboardShortcuts()">
    <i class="pi pi-desktop"></i>
    <span>{{ 'KEYBOARD_SHORTCUTS.TITLE' | translate }}</span>
</div>

<div class="logout-section" (click)="logout()">
    {{ "HEADER.LOGOUT" | translate }}
</div>
